import { isSSR } from '~/utils/isSSR';

export default defineNuxtPlugin(async (nuxtApp) => {
  const isServer = isSSR();

  if (isServer) {
    nuxtApp.vueApp.directive('tooltip', {
      getSSRProps() {
        return {};
      },
    });
  } else {
    const { default: AtomicTooltip } = await import('@atomic-ui/tooltip/tooltip.js');
    nuxtApp.vueApp.directive('tooltip', AtomicTooltip);
  }
});
